module.exports = __webpack_public_path__ + "img/regular-embed.a63aa958.png";